__turbopack_context__.v({
  "expanded-email-form-enter": "styles-module-scss-module__53AFZG__expanded-email-form-enter",
  "expandedEmailForm": "styles-module-scss-module__53AFZG__expandedEmailForm",
});
